import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { resolve, reject } from 'redux-optimist-promise';
import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';
import { FETCH_TRANSPORT_STATIONS } from 'Store/booking/transport-stations/transportStations.action';
type State = {
  alternativeTransports: Array<AlternativeTransport>;
  selectedTransport?: AlternativeTransport;
  selectedTransportId?: string | null;
  proposalTransport?: AlternativeTransport;
  cityTransports: {
    loading: boolean;
    data: CityTransports;
    cityId: string | null | undefined;
  };
};
const sortPath = 'price.value';
const initialState: State = {
  alternativeTransports: [],
  selectedTransport: undefined,
  selectedTransportId: null,
  cityTransports: {
    loading: false,
    cityId: null,
    data: {
      airports: [],
      trainStations: [],
      ports: [],
    },
  },
};

function transportsReducer(state: State = initialState, action: Action<any>): State {
  switch (get(action, 'type')) {
    case resolve(FETCH_ADDITIONAL_TRANSPORTS):
      const { additionalTransports, selectedTransport } = action.payload;
      const alternativeTransports = sortBy(additionalTransports || [], sortPath).map(
        (transport, index) => ({ ...transport, transportNumber: index + 1 }),
      );
      return {
        ...state,
        selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports,
        selectedTransportId: null,
      };

    case FETCH_TRANSPORT_STATIONS:
      return {
        ...state,
        cityTransports: { ...state.cityTransports, loading: true, cityId: action.payload },
      };

    case resolve(FETCH_TRANSPORT_STATIONS):
      return { ...state, cityTransports: { ...state.cityTransports, data: action.payload } };

    case reject(FETCH_TRANSPORT_STATIONS):
      return { ...state, cityTransports: { ...state.cityTransports } };

    default:
      return state;
  }
}

export default transportsReducer;
